import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { WebSocketApi } from '../api/webSocketApi';
import { RootState } from '../rootReducer';
import { ThunkConfig } from './thunkConfig';

export const startWebsocket = createAsyncThunk<string, void, ThunkConfig>(`websocket/start`, async () => {
    return WebSocketApi.getWebsocketEndpoint();
});

export type WebsocketState = {
    endpoint: string | null;
    retry: number;
};

const initialState: WebsocketState = {
    endpoint: null,
    retry: 1,
};

export const websocketSlice = createSlice({
    name: 'websocket',
    initialState,
    reducers: {
        increaseRetry: (state) => {
            state.endpoint = null;
            state.retry += 1;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(startWebsocket.fulfilled, (state, action) => {
            state.endpoint = action.payload;
        });
        builder.addCase(startWebsocket.rejected, () => {
            increaseRetry();
        });
    },
});

export const { increaseRetry } = websocketSlice.actions;

export const selectWebsocket = (state: RootState): WebsocketState => state.websocket;

export const websocketReducer = websocketSlice.reducer;
